const BAIL_TIMEOUT_MS = 10000;
export function observeVisibleLabelCells(scrollElement, onComplete) {
  const start = performance.now();
  const observed = new WeakSet();
  const pending = new Set();
  const visible = new Set();
  let done = false;
  let bailTimer = 0;
  let io = null;
  let mo = null;
  const cleanup = () => {
    var _io, _mo;
    if (done) return;
    done = true;
    (_io = io) === null || _io === void 0 || _io.disconnect();
    (_mo = mo) === null || _mo === void 0 || _mo.disconnect();
    clearTimeout(bailTimer);
  };
  const maybeComplete = () => {
    if (done || pending.size > 0 || visible.size === 0) return;
    for (const cell of visible) {
      var _cell$textContent;
      if (((_cell$textContent = cell.textContent) !== null && _cell$textContent !== void 0 ? _cell$textContent : '').trim().length === 0) return;
    }
    onComplete(performance.now() - start);
    cleanup();
  };
  const observeLabelCells = () => {
    if (done || !io) return;
    const cells = scrollElement.querySelectorAll('td[data-column-index="0"]');
    for (const cell of cells) {
      if (!observed.has(cell)) {
        observed.add(cell);
        pending.add(cell);
        io.observe(cell);
      }
    }
  };
  io = new IntersectionObserver(entries => {
    for (const entry of entries) {
      pending.delete(entry.target);
      if (entry.isIntersecting) {
        visible.add(entry.target);
      } else {
        visible.delete(entry.target);
      }
    }
    maybeComplete();
  }, {
    root: scrollElement,
    threshold: 0,
    rootMargin: '0px'
  });
  mo = new MutationObserver(() => {
    observeLabelCells();
    maybeComplete();
  });
  observeLabelCells();
  mo.observe(scrollElement, {
    subtree: true,
    childList: true,
    characterData: true
  });
  bailTimer = window.setTimeout(cleanup, BAIL_TIMEOUT_MS);
  return cleanup;
}